/**
 * @param {String} string
 * @return {Boolean}
 */
export default function isEmptyString(string) {
  return string.length === 0 || !string.trim();
}
